import * as React from 'react'
import {Box, Chip} from "@mui/material";


export default function alertNameColumn() {
	return {
		name: 'pricingAlert', label: 'Repricing Rule',
		options: {
			headerAlign: 'center',
			setCellProps: () => ({ sx: { minWidth: '180px' }}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				<Chip label={value} />
			</Box>
		}
	}
}